import React from 'react';
import { LayoutTemplate, Sparkles } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';

export const PreviewEmptyExperience = ({ hasPreviewSource = false, className = '' }) => {
  const { t } = useI18n();

  return (
    <div
      className={`relative flex min-h-[560px] flex-1 items-center justify-center overflow-hidden bg-[radial-gradient(circle_at_18%_12%,rgba(20,184,166,0.16)_0%,transparent_42%),radial-gradient(circle_at_82%_88%,rgba(249,115,22,0.14)_0%,transparent_40%),radial-gradient(circle_at_top,#fffdf6_0%,#f7f0e2_40%,#f5f5f7_100%)] p-6 dark:bg-[radial-gradient(circle_at_18%_12%,rgba(45,212,191,0.12)_0%,transparent_42%),radial-gradient(circle_at_82%_88%,rgba(251,146,60,0.1)_0%,transparent_40%),radial-gradient(circle_at_top,#11212b_0%,#0f172a_45%,#020617_100%)] ${className}`}
    >
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="preview-loading-orb preview-loading-orb-a" />
        <div className="preview-loading-orb preview-loading-orb-b" />
        <div className="preview-loading-grid" aria-hidden="true" />
      </div>

      <div className="relative z-10 w-full max-w-lg">
        <div className="relative mx-auto flex h-28 w-28 items-center justify-center">
          <span className="preview-loading-ring preview-loading-ring-outer" aria-hidden="true" />
          <span className="preview-loading-ring preview-loading-ring-inner" aria-hidden="true" />
          <div className="relative flex h-16 w-16 items-center justify-center rounded-[1.35rem] bg-[linear-gradient(135deg,#123629_0%,#1f6f5f_55%,#14b8a6_100%)] text-white shadow-[0_20px_50px_rgba(18,54,41,0.35)] dark:shadow-[0_20px_50px_rgba(20,184,166,0.22)]">
            <LayoutTemplate size={30} strokeWidth={2.2} />
            <Sparkles
              size={14}
              className="absolute -end-1 -top-1 text-amber-300 drop-shadow-sm"
              strokeWidth={2.4}
              aria-hidden="true"
            />
          </div>
        </div>

        <h3 className="mt-6 text-center text-xl font-semibold tracking-tight text-slate-900 dark:text-white">
          {t('previewEmptyTitle')}
        </h3>
        <p className="mt-2 text-center text-sm leading-7 text-slate-600 dark:text-slate-300">
          {hasPreviewSource ? t('previewBuildHint') : t('previewEmptyBody')}
        </p>
      </div>
    </div>
  );
};
